<template>
  <div class="serviceGrid">
    <div class="serviceCard" v-for="service in availableServices" :key="service.key">
      <CardService
        @clickCard="$emit('select', $event)"
        :disabled="selectedServices.includes(service.key)"
        :service="service"
        small
      />
    </div>
    <div class="serviceCard" v-for="service in availableCustomServices" :key="service.key">
      <CardService @clickCard="$emit('select', $event)" :disabled="service.disabled" :service="service" small />
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

import CardService from '@/components/onboarding/UI/CardService'

const GET_SERVICE_TYPES = gql`
  query serviceTypes($country: String!) {
    serviceTypes(country: $country)
  }
`

export default {
  name: 'SelectService',

  components: { CardService },

  props: {
    selectedServices: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      availableServices: [],
      availableCustomServices: this.getCustomServices()
    }
  },

  apollo: {
    availableServices: {
      query: GET_SERVICE_TYPES,
      skip() {
        return !this.$get(this.$store.getters, 'currentShop.country')
      },
      update(data) {
        return data.serviceTypes
          .filter(type => type != 'custom')
          .map(type => ({
            key: type,
            icon: this.defineServiceIcon(type),
            active: false,
            value: type
          }))
      },
      variables() {
        return { country: this.$store.getters.currentShop.country }
      }
    }
  },

  methods: {
    defineServiceIcon(key) {
      const service = this.$const.serviceTypeValues.find(el => el.value === key)
      return service ? service.icon : ''
    },
    getCustomServices() {
      let customServiceArray = []
      for (let service of this.$store.getters.currentShop.services) {
        if (service.serviceType === 'custom' && service.icon != '') {
          customServiceArray.push(service)
        }
      }
      //This allows to see the problem when coming back after enabling a custom service
      return customServiceArray.map(service => ({
        key: service.serviceUuid,
        icon: service.icon,
        active: false,
        value: service.serviceType,
        name: service.name,
        disabled: service.enabled
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.serviceGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(186px, 1fr));
  grid-auto-flow: row;
}

.serviceCard {
  margin: 10%;
}
</style>
